const moment = require("moment");
import { GT_ENDPOINT } from "@/constants/settings";
export const datesAreDiffernt = (dateA, dateB) => {
  return dateA.toString().split("T")[0] != dateB.toString().split("T")[0];
};
export const getDatesForTemplateItem = (start, templateItem) => {
  const itiStartDate = moment(start).startOf("day");
  const offset = Number(templateItem.day) - 1;
  const startDate = itiStartDate.add(offset, "days").startOf("day");
  const duration =
    templateItem.supplier.serviceType == "ACCOMMODATION"
      ? Number(templateItem.duration)
      : Number(templateItem.duration) - 1;
  return {
    startDate,
    endDate: moment(startDate).add(duration, "days").startOf("day"),
  };
};
export const itiItemDuration = (item) => {
  let start = moment(item.startDate).startOf("day");
  let end = moment(item.endDate).startOf("day");
  if (start.isValid() && end.isValid()) {
    let d = end.diff(start, "days");
    let addDay = item.serviceType != "ACCOMMODATION" || item.isExtra ? 1 : 0;
    //let addDay = 1;
    if (item.serviceType == "TRANSPORT") {
      //http://tracker.globetrack.ie/issues/5905
      // only if both pickup and dropoff time are set - https://tracker.globetrack.ie/issues/9623
      if (
        item.remarks &&
        item.remarks.pickupTime &&
        item.remarks.pickupTime != "" &&
        item.remarks.dropoffTime &&
        item.remarks.dropoffTime != ""
      ) {
        const pickupTime =
          item.remarks &&
          item.remarks.pickupTime &&
          item.remarks.pickupTime != ""
            ? item.remarks.pickupTime
            : "00:00";
        const dropoffTime =
          item.remarks &&
          item.remarks.dropoffTime &&
          item.remarks.dropoffTime != ""
            ? item.remarks.dropoffTime
            : "00:01";
        addDay =
          Number(dropoffTime.replace(/\D/, "")) >
          Number(pickupTime.replace(/\D/, ""))
            ? 1
            : 0;
      }
    }
    return d == 0 ? 1 : d + addDay;
  }
  return 1;
};
export const durationInDays = (startDate, endDate) => {
  let start = moment(startDate).startOf("day");
  let end = moment(endDate).startOf("day");
  if (start.isValid() && end.isValid()) {
    const duration = end.diff(start, "days");
    return duration;
  }

  return 0;
};
export const reportsDateFormat = (isoString) => {
  return moment(isoString).format("DD-MM-YYYY");
};
export const reportUrl = (format) => (id) => {
  const host = GT_ENDPOINT.replace("graphql", "");
  const time = new Date().getMilliseconds();
  const url = `${host}report/get_document?t=${time}&attachment=1&format=${format}&template=${id}`;
  return url;
};

export const camelize = (str) => {
  return str
    .toLowerCase()
    .replace(/[^A-Za-z0-9]/g, " ")
    .split(" ")
    .reduce(
      (result, word) =>
        result + word.charAt(0).toUpperCase() + word.slice(1) + " ",
      ""
    );
};

export const nonCaseToSnakeCase = (str) => {
  return str.split(" ").join("_").toLowerCase();
};

export const getItiItemOrder = (itHeader) => (items) => (item) => {
  let orderNo = 0;
  const itStart = moment(itHeader.startDate);
  const itEnd = moment(itHeader.endDate);
  const duration = itEnd.diff(itStart.startOf("day"), "days");
  let dayOfStay = 0;
  for (let i = 0; i <= duration; i++) {
    const day = moment(itStart).add(i, "days");
    if (day.isSame(moment(item.startDate), "day")) {
      dayOfStay = i + 1;
      break;
    }
  }
  const serviceInc = 5;
  const order =
    dayOfStay * 100 +
    (items.filter((i) =>
      moment(i.startDate)
        .startOf("day")
        .isSame(moment(item.startDate).startOf("day"), "day")
    ).length +
      1) *
      serviceInc;
  1;
  return order;
};
export const sortBy = (fieldName) => (a, b) => {
  if (a[fieldName] < b[fieldName]) {
    return -1;
  }
  if (a[fieldName] > b[fieldName]) {
    return 1;
  }
  return 0;
};
export const sortByFn = (fn) => (a, b) => {
  if (fn(a) < fn(b)) {
    return -1;
  }
  if (fn(a) > fn(b)) {
    return 1;
  }
  return 0;
};

export const sortByDateField = (fieldName) => (a, b) =>
  new Date(a[fieldName]) - new Date(b[fieldName]);

export const sortByDate = (a, b) => new Date(a) - new Date(b);
export const sortByDateWithFormat = (format) => (a, b) =>
  moment(a, format) - moment(b, format);

export const sortByReference = sortByFn((val) =>
  val.match(/\D\d{5}/g) ? val.match(/\D\d{5}/g).slice(1) : 0
);
export const sortByInvNo = sortByFn((val) =>
  val.match(/\d{8}/g) ? val.match(/\d{8}/g)[0] : 0
);

export const removeGQLTypename = (item) => {
  const { __typename, ...rest } = item.node ? item.node : item;
  return rest;
};
export const getValueByPath = (path, obj) =>
  path.split(".").reduce((prev, curr) => (prev ? prev[curr] : null), obj);
export const pagingOptions = {
  footerProps: { itemsPerPageOptions: [50, 100, 200, 250, 500, -1] },
  itemsPerPage: -1,
};
export const uniqueByProp = (items, prop) =>
  items.filter(
    (obj, pos, arr) =>
      arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) == pos
  );
export const updateObj = (src, target, props) => {
  for (const prop of props) {
    target[prop] = src[prop];
  }
};

export const groupByProp = (items, prop) => {
  return items.reduce((h, item) => {
    const key = item[prop];
    if (!h[key]) {
      h[key] = [];
    }
    h[key].push(item);
    return h;
  }, {});
};

export const groupByFn = (items, fn) => {
  return items.reduce((h, item) => {
    const key = fn(item);
    if (!h[key]) {
      h[key] = [];
    }
    h[key].push(item);
    return h;
  }, {});
};

export const extraDisplayQty = (extra) => {
  //console.log(extra);
  if (extra.isChildOnly) {
    return extra.children;
  }
  if (extra.isInfantOnly) {
    return extra.infants;
  }

  return extra.adults;
};

export const getTotal = (list, fn) => {
  return list.reduce((t, item) => {
    t += Number(fn(item));
    return t;
  }, 0);
};
export const downloadFile = (filename, text) => {
  const element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," + encodeURIComponent(text)
  );
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};
export const downloadHtml = (filename, content) => {
  const html = `<!DOCTYPE html>
<html>
<head>
<title>${filename}</title>
<style>
  body {
    font-family: Verdana, sans-serif;
  }
  table {
    border-collapse: collapse;
  }
  table, th, td {
    border: 1px solid;
  }
  th, td {
    padding: 15px;
    text-align: left;
  }
</style>
</head>
<body>
${content}
</body>
</html>`;
  downloadFile(filename, html);
};
export const stripHtml = (html) => {
  let tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};



// WEBPACK FOOTER //
// ./src/helpers/index.js